import { type AppConfiguration } from '#app/types.js';
import { createContext } from 'react';

export const AppConfigurationContext = createContext<AppConfiguration | null>(
  null,
);
